const initStickyMobileArrow = () => {
    const section = document.querySelector(".js-sticky-arrow-box");
    if (!section) return;
    const arrow = section.querySelector(".js-scroll-top-arrow");
    if (!arrow) return;

    window.addEventListener('scroll', function () {
        var sectionTop = section.offsetTop;
        var scrollPosition = window.scrollY || document.documentElement.scrollTop;

        // Check if the window scroll position is past the section by at least 200% of the viewport height
        if (scrollPosition >= sectionTop + window.innerHeight) {
            arrow.classList.add('is-visible');
        } else {
            arrow.classList.remove('is-visible');
        }
    }, { passive: true });
};


export { initStickyMobileArrow };
